<!--
일괄기능 컨트롤러에 사용되는
    - sticky 기능의 mixin
------------------------------------

-->

<script>
    export default {
        props: {
            // Sticky 기능 설정
            onSticky: {
                type: Boolean,
                default: false
            },
        },
    }
</script>